"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UrlSlug = void 0;
var urlSlug_enum_1 = require("./enum/urlSlug.enum");
Object.defineProperty(exports, "UrlSlug", { enumerable: true, get: function () { return urlSlug_enum_1.UrlSlug; } });
//# sourceMappingURL=index.js.map